// import axios from 'axios'
import { post, put, get } from "@/api/api";

export const actions = {
  fetchAviss({ commit }) {
    // const { pageNumber = 0, pageSize = state.pagination.size } = params
    return get(`/canal/avis`).then(({ data }) => {
      commit("addAviss", data);
    });
  },
  fetchAvissPage({ commit }, params) {
    // const { pageNumber = 0, pageSize = state.pagination.size } = params;
    return get(`/canal/avis/page?` + params).then(({ data }) => {
      commit("addAvissPage", data);
    });
  },
  createAvis({ commit }, avis) {
    return post("/canal/avis", avis).then(({ data }) => {
      commit("addAvis", data);
    });
  },
  updateAvis({ commit }, avis) {
    return put(`/canal/avis${avis.id}`, avis).then(({ data }) => {
      commit("replaceAvis", data);
    });
  },
  createOrUpdateAvis({ dispatch }, avis) {
    if (avis.id !== undefined) {
      return dispatch("updateAvis", avis);
    } else {
      return dispatch("createAvis", avis);
    }
  },
  selectAvis({ commit }, avis) {
    commit("setAvis", avis);
  },
};
